import { useEffect } from 'react';
import { CustomSpinner } from '../../../components';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { ScheduleTag } from './components/ScheduleTag';
import { selectSchedule, selectScheduleStaleFromPlay } from '../../../features/schedule/scheduleSelectors';
import { useParams } from 'react-router-dom';
import { fetchDataForSchedule } from '../../../features/schedule/scheduleActions';
import { TagIdsEnum } from '../../../constant/navigation';

export const Schedule = () => {
    const { id, tag } = useParams<{ id: string; tag: string }>();

    const { isLoading, error } = useAppSelector(selectSchedule);
    const scheduleStaleFromPlay = useAppSelector(selectScheduleStaleFromPlay);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const force = tag === TagIdsEnum.SCHEDULE && scheduleStaleFromPlay;
        dispatch(fetchDataForSchedule(+id, force));
    }, [dispatch, id, tag, scheduleStaleFromPlay]);

    return <div>{(isLoading && <CustomSpinner />) || error || <ScheduleTag />}</div>;
};
